import XCircleIcon from '@heroicons/react/20/solid/XCircleIcon.js';
import clsx from 'clsx';

export function ErrorMessage({ title, details, className }) {
  return (
    <div
      className={clsx(
        'text-sm mb-5 p-4 flex gap-3 bg-error-50 text-error-500 rounded-md',
        className,
      )}
    >
      <XCircleIcon className="size-5 min-w-5 min-h-5 text-error-400" />
      <div className="">
        <div className="mb-1 font-medium">{title}</div>
        <div className="text-error-700 *:pl-4 *:list-disc">{details}</div>
      </div>
    </div>
  );
}
